<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h2>{{ $t("message.login") }}</h2>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    prepend-icon="ni ni-email-83"
                    :placeholder="$t('message.email')"
                    v-model="model.email"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    :placeholder="$t('message.password')"
                    v-model="model.password"
                  >
                  </base-input>
                  <label v-if="wrongpass" style="color:red;"
                    >{{ $t('message.wrong_password') }}</label
                  >
                  <b-form-checkbox v-model="model.rememberMe"
                    >{{ $t('message.remember_me') }}</b-form-checkbox
                  >
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >{{ $t('message.logga_in') }}</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link :to="{ name: 'reset'}" class="text-light"
                ><small>{{ $t('message.logga_in') }}?</small></router-link
              >
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link :to="{ name: 'register'}" class="text-light"
                ><small
                  >{{ $t('message.register') }}</small
                ></router-link
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import qs from "qs";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.$cookies.config("30d");

export default {
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false
      },
      wrongpass: false
    };
  },
  methods: {
    onSubmit() {
      //console.log(this.model.email);
      //console.log(this.model.password);
      Vue.axios
        .post(
          "/app/login_survey",
          qs.stringify({
            username: this.model.email,
            loginpassword: this.model.password
          })
        )
        .then(({ data }) => {
          if (data.status == 1) {
            this.wrongpass = false;
            if (!this.model.rememberMe) {
              Vue.$cookies.config("0");
            }
            Vue.$cookies.set("userid", data.userid);
            Vue.$cookies.set("username", data.username);
            Vue.$cookies.set("email", data.email);
            Vue.$cookies.set("token", data.token);
            //this.$modal.hide("login-modal");
            //this.$emit("loginevent");
            console.log("Login Yay!");
            this.$router.push({ name: "mina_sidor" });
          } else {
            //show error
            this.wrongpass = true;
            console.log("login issue");
          }
        });
    }
  }
};
</script>
<style scoped>
.bg-gradient-success {
  background: linear-gradient(87deg, #e9ecef, #5da0e3) !important;
}
</style>
